var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 30.4635,
    cy: 30,
    r: 30,
    fill: "#2B59FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8913 33.0935C37.546 33.4282 37.3873 33.9122 37.466 34.3868L38.6513 40.9468C38.7513 41.5028 38.5166 42.0655 38.0513 42.3868C37.5953 42.7202 36.9886 42.7602 36.4913 42.4935L30.586 39.4135C30.3806 39.3042 30.1526 39.2455 29.9193 39.2388H29.558C29.4326 39.2575 29.31 39.2975 29.198 39.3588L23.2913 42.4535C22.9993 42.6002 22.6686 42.6522 22.3446 42.6002C21.5553 42.4508 21.0286 41.6988 21.158 40.9055L22.3446 34.3455C22.4233 33.8668 22.2646 33.3802 21.9193 33.0402L17.1046 28.3735C16.702 27.9828 16.562 27.3962 16.746 26.8668C16.9246 26.3388 17.3806 25.9535 17.9313 25.8668L24.558 24.9055C25.062 24.8535 25.5046 24.5468 25.7313 24.0935L28.6513 18.1068C28.7206 17.9735 28.81 17.8508 28.918 17.7468L29.038 17.6535C29.1006 17.5842 29.1726 17.5268 29.2526 17.4802L29.398 17.4268L29.6246 17.3335H30.186C30.6873 17.3855 31.1286 17.6855 31.3593 18.1335L34.318 24.0935C34.5313 24.5295 34.946 24.8322 35.4246 24.9055L42.0513 25.8668C42.6113 25.9468 43.0793 26.3335 43.2646 26.8668C43.4393 27.4015 43.2886 27.9882 42.878 28.3735L37.8913 33.0935Z",
    fill: "#2B59FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon2);
export default __webpack_public_path__ + "static/media/card_icon2.070b38cb8f6be62eb9251c7a93236d26.svg";
export { ForwardRef as ReactComponent };